import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=f12841aa"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"
import style0 from "./Questions.vue?vue&type=style&index=0&id=f12841aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports